import { AxiosRequestConfig } from "axios";

import { useApi } from "../useApi/useApi";
import { Limit } from "../../models/Limit";

/**
 * Fetch hook for upload targets
 */
export const useGetLimit = () => {
  const req: AxiosRequestConfig = {
    url: "/api/limit",
    method: "get",
    headers: { "Content-Type": "application/json" },
  };
  const { state } = useApi<Limit>(req);
  return state;
};
